export const SKILLS_ACCESS = 'skills-access';
export const BILLING_READ = 'billing-read';
export const CAPACITY_LIMITS_V2_READ = 'capacity-limits-v2-read';